// 🐣 KIDS BEGINNERS BOOTCAMP DATABASE (36 CLASSES, 540 ACTIVITIES)

export const BOOTCAMP_CLASSES = [
  { id: 1, name: "Class 1: Intro to Chessboard", tag: "intro_board", icon: "🏁", desc: "Learn about light and dark squares!" },
  { id: 2, name: "Class 2: Ranks and Files", tag: "ranks_files", icon: "📏", desc: "Understand ranks (numbers) and files (letters)." },
  { id: 3, name: "Class 3: Diagonals & Center", tag: "diagonals_center", icon: "❌", desc: "Learn about diagonals and the central four squares." },
  { id: 4, name: "Class 4: The Rook (Castle)", tag: "rook_move", icon: "♖", desc: "Learn how the Rook moves in straight lines." },
  { id: 5, name: "Class 5: Rook Captures", tag: "rook_capture", icon: "🍎", desc: "Capture undefended stars with your Rook." },
  { id: 6, name: "Class 6: The Bishop", tag: "bishop_move", icon: "♗", desc: "Learn how the Bishop slides on diagonals." },
  { id: 7, name: "Class 7: Bishop Captures", tag: "bishop_capture", icon: "🍏", desc: "Capture stars on matching diagonal colors." },
  { id: 8, name: "Class 8: The Queen", tag: "queen_move", icon: "♕", desc: "Master the most powerful piece on the board!" },
  { id: 9, name: "Class 9: Queen Captures", tag: "queen_capture", icon: "🍇", desc: "Eat stars across files, ranks, and diagonals." },
  { id: 10, name: "Class 10: The King", tag: "king_move", icon: "♔", desc: "Learn the tiny, single-step moves of the King." },
  { id: 11, name: "Class 11: The Knight", tag: "knight_move", icon: "♘", desc: "Master the tricky L-shape jumps of the Knight." },
  { id: 12, name: "Class 12: Knight Captures", tag: "knight_capture", icon: "🍒", desc: "Jump over blockers to capture target stars." },
  { id: 13, name: "Class 13: The Pawn", tag: "pawn_move", icon: "♙", desc: "Walk forward with soldiers (1 or 2 steps)." },
  { id: 14, name: "Class 14: Pawn Captures", tag: "pawn_capture", icon: "🍓", desc: "Capture enemy targets diagonally forward." },
  { id: 15, name: "Class 15: Pawn Promotion", tag: "pawn_promotion", icon: "👑", desc: "Reach the 8th rank to promote into a Queen!" },
  { id: 16, name: "Class 16: Safe Squares", tag: "safe_squares", icon: "🟢", desc: "Identify squares where pieces cannot be eaten." },
  { id: 17, name: "Class 17: Unsafe Squares", icon: "🔴", tag: "unsafe_squares", desc: "Avoid red zones attacked by enemy pieces." },
  { id: 18, name: "Class 18: Protecting Pieces", icon: "🛡️", tag: "defend_piece", desc: "Guard your teammates under attack." },
  { id: 19, name: "Class 19: Double Attacks", icon: "🔱", tag: "double_attack", desc: "Attack two enemy pieces at the same time." },
  { id: 20, name: "Class 20: Free Captures", icon: "💎", tag: "free_captures", desc: "Find and capture hanging, undefended pieces." },
  { id: 21, name: "Class 21: Piece Trades", icon: "⚖️", tag: "trades", desc: "Understand trading values (good trades vs bad trades)." },
  { id: 22, name: "Class 22: Castling Magic", icon: "🏰", tag: "castling", desc: "Hide your King behind a wall of pawns." },
  { id: 23, name: "Class 23: Castling Rules", icon: "🛑", tag: "castling_rules", desc: "Learn when castling is blocked or forbidden." },
  { id: 24, name: "Class 24: En Passant Capture", icon: "👻", tag: "en_passant", desc: "Capture pawns sideways using the ghost-walk rule." },
  { id: 25, name: "Class 25: Board Setup", icon: "🏗️", tag: "board_setup", desc: "Place all pieces on their correct starting squares." },
  { id: 26, name: "Class 26: Checking the King", icon: "⚡", tag: "check", desc: "Attack the enemy King and sound the alert!" },
  { id: 27, name: "Class 27: Getting Out of Check", icon: "🏃", desc: "Escape checks by Running, Blocking, or Capturing." },
  { id: 28, name: "Class 28: What is Checkmate?", icon: "💀", tag: "checkmate_concept", desc: "Learn when the King has no escapes left." },
  { id: 29, name: "Class 29: Rook Ladder Mate", icon: "🪜", tag: "ladder_mate", desc: "Perform the famous Ladder Mate with two Rooks." },
  { id: 30, name: "Class 30: Queen Kiss of Death", icon: "💋", tag: "kiss_death", desc: "Deliver mate right next to the enemy King." },
  { id: 31, name: "Class 31: Scholar's Mate", icon: "🎓", tag: "scholars_mate", desc: "Execute or defend the quick 4-move checkmate." },
  { id: 32, name: "Class 32: Stalemate Draw", icon: "🤝", tag: "stalemate", desc: "Learn about stalemate when the King is trapped but safe." },
  { id: 33, name: "Class 33: Draws & Rules", icon: "📝", tag: "draw_rules", desc: "Learn draw conditions (repetition, material)." },
  { id: 34, name: "Class 34: Back Rank Mate", icon: "🚪", tag: "back_rank", desc: "Checkmate the King behind their own pawn shield." },
  { id: 35, name: "Class 35: Opening Traps", icon: "🪤", tag: "opening_traps", desc: "Avoid early mistakes and capture greedy pieces." },
  { id: 36, name: "Class 36: Bootcamp Graduation", icon: "🎓🏆", tag: "graduation", desc: "Complete the ultimate exam and graduate!" }
];

// Helper to generate coordinates
const FILES = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
const RANKS = [1, 2, 3, 4, 5, 6, 7, 8];

// Programmatically generate 15 tasks for each class to populate a total of 540 activities
export const getTasksForClass = (classId) => {
  const tasks = [];
  const classObj = BOOTCAMP_CLASSES.find(c => c.id === classId);
  if (!classObj) return [];

  for (let t = 1; t <= 15; t++) {
    const taskId = `c${classId}_t${t}`;
    
    switch (classId) {
      case 1: // Intro to Chessboard
        const sq = FILES[(t * 3) % 8] + RANKS[(t * 5) % 8];
        const isDark = (FILES.indexOf(sq[0]) + RANKS.indexOf(parseInt(sq[1]))) % 2 === 1;
        tasks.push({
          id: taskId,
          type: "board_click",
          question: `Is the square ${sq.toUpperCase()} Light or Dark? 🏁`,
          fen: "8/8/8/8/8/8/8/8 w - - 0 1",
          clickTargets: [sq],
          options: ["⬜ Light Square", "⬛ Dark Square"],
          answer: isDark ? "⬛ Dark Square" : "⬜ Light Square"
        });
        break;

      case 2: // Ranks and Files
        const selectRank = (t % 2 === 0);
        const randIndex = t % 8;
        const targetVal = selectRank ? RANKS[randIndex] : FILES[randIndex];
        const questionText = selectRank 
          ? `Click on ANY square located on Rank ${targetVal} 📏` 
          : `Click on ANY square located on File ${targetVal.toUpperCase()} 📏`;
        const targets = selectRank 
          ? FILES.map(f => `${f}${targetVal}`) 
          : RANKS.map(r => `${targetVal}${r}`);
        tasks.push({
          id: taskId,
          type: "board_click",
          question: questionText,
          fen: "8/8/8/8/8/8/8/8 w - - 0 1",
          clickTargets: targets,
          isDirectGridClick: true
        });
        break;

      case 3: // Diagonals & Center
        if (t <= 5) {
          // Center squares
          const centers = ['d4', 'e4', 'd5', 'e5'];
          const centerTarget = centers[t % 4];
          tasks.push({
            id: taskId,
            type: "board_click",
            question: `Click on the central square ${centerTarget.toUpperCase()} ❌`,
            fen: "8/8/8/8/8/8/8/8 w - - 0 1",
            clickTargets: [centerTarget],
            isDirectGridClick: true
          });
        } else {
          // Click diagonal squares
          const diagSq = FILES[t % 8] + RANKS[t % 8];
          tasks.push({
            id: taskId,
            type: "board_click",
            question: `Click on the square ${diagSq.toUpperCase()} lying on a main diagonal ❌`,
            fen: "8/8/8/8/8/8/8/8 w - - 0 1",
            clickTargets: [diagSq],
            isDirectGridClick: true
          });
        }
        break;

      case 4: // The Rook (Castle) Move
        // Move Rook to collect stars
        const rookStart = FILES[t % 4 + 2] + RANKS[(t * 3) % 4 + 2];
        const rookApples = [
          FILES[FILES.indexOf(rookStart[0]) + (t % 2 === 0 ? 1 : -1)] + rookStart[1],
          rookStart[0] + RANKS[RANKS.indexOf(parseInt(rookStart[1])) + (t % 2 === 0 ? -1 : 1)]
        ];
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Rook",
          startPos: rookStart,
          apples: rookApples,
          question: "Slide straight (up, down, left, right) to collect all Stars! ⭐",
          itemIcon: "⭐"
        });
        break;

      case 5: // Rook Captures
        // Slide rook to capture stars
        const rStart = 'a1';
        const rApples = ['a4', 'd4', 'd8', 'h8'].slice(0, Math.min(2 + (t % 3), 4));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Rook",
          startPos: rStart,
          apples: rApples,
          question: "Use your Rook to capture the target stars sequentially! 🍎",
          itemIcon: "⭐"
        });
        break;

      case 6: // The Bishop Move
        // Slide bishop to collect stars
        const bStart = 'd4';
        const bApples = ['f6', 'h4', 'f2'].slice(0, Math.min(1 + (t % 3), 3));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Bishop",
          startPos: bStart,
          apples: bApples,
          question: "Slide diagonally (X-shape) to collect all Stars! ⭐",
          itemIcon: "⭐"
        });
        break;

      case 7: // Bishop Captures
        const bisStart = 'f1';
        const bisApples = ['c4', 'a6', 'c8'].slice(0, Math.min(2 + (t % 2), 3));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Bishop",
          startPos: bisStart,
          apples: bisApples,
          question: "Capture all the target stars diagonally with your Bishop! 🍏",
          itemIcon: "⭐"
        });
        break;

      case 8: // Queen Move
        const qStart = 'd4';
        const qApples = ['d7', 'g7', 'g4', 'b2'].slice(0, Math.min(2 + (t % 3), 4));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Queen",
          startPos: qStart,
          apples: qApples,
          question: "Fly like a Queen (straight OR diagonally) to eat the stars! ♕",
          itemIcon: "⭐"
        });
        break;

      case 9: // Queen Captures
        const quStart = 'c3';
        const quApples = ['c7', 'f7', 'f4', 'h4'].slice(0, Math.min(2 + (t % 3), 4));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Queen",
          startPos: quStart,
          apples: quApples,
          question: "Clean the board by capturing all target stars with your Queen! 🍇",
          itemIcon: "⭐"
        });
        break;

      case 10: // The King
        const kStart = 'e4';
        const kApples = ['e5', 'f5', 'f4'].slice(0, Math.min(1 + (t % 3), 3));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "King",
          startPos: kStart,
          apples: kApples,
          question: "Step 1 block in any direction to capture the crowns! 👑",
          itemIcon: "👑"
        });
        break;

      case 11: // The Knight
        const nStart = 'd4';
        const nApples = ['e6', 'g5', 'f3'].slice(0, Math.min(1 + (t % 3), 3));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Knight",
          startPos: nStart,
          apples: nApples,
          question: "Jump L-shapes (2 blocks straight, 1 sideways) to capture the Stars! ♘",
          itemIcon: "⭐"
        });
        break;

      case 12: // Knight Captures
        const knStart = 'e4';
        const knApples = ['c5', 'b7', 'd6'].slice(0, Math.min(1 + (t % 3), 3));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Knight",
          startPos: knStart,
          apples: knApples,
          question: "Dodge the blockers and capture all stars with your Knight! 🍒",
          itemIcon: "⭐"
        });
        break;

      case 13: // The Pawn
        const pStart = `e${t % 2 === 0 ? 2 : 3}`;
        const pTarget = pStart === 'e2' ? ['e3', 'e4'] : ['e4'];
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Pawn",
          startPos: pStart,
          apples: pTarget,
          question: "Walk forward straight with your Pawn (1 step, or 2 steps from start)! ♙",
          itemIcon: "⭐"
        });
        break;

      case 14: // Pawn Captures
        const pawStart = 'e4';
        const pawApples = ['d5', 'f5'].slice(0, Math.min(1 + (t % 2), 2));
        tasks.push({
          id: taskId,
          type: "collect_items",
          piece: "Pawn",
          startPos: pawStart,
          apples: pawApples,
          question: "Remember: Pawns move straight but capture diagonally forward! 🍓",
          itemIcon: "⭐"
        });
        break;

      case 15: // Pawn Promotion
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Advance your pawn to the last row to promote into a Queen! 👑",
          fen: "8/4P3/8/8/8/8/8/k6K w - - 0 1",
          correctMove: { from: "e7", to: "e8" },
          successMessage: "Awesome! You promoted a Queen! 👑"
        });
        break;

      case 16: // Safe Squares
        const ksSq = 'e4';
        // Placed enemy rook on e8 attacking file e, and queen on a4 attacking rank 4
        // Safe squares for king: d5, f5, d3, f3
        const safeOptions = ['d5', 'f5', 'd3', 'f3'];
        const selectedSafe = safeOptions[t % 4];
        tasks.push({
          id: taskId,
          type: "safe_squares",
          question: "The King is under fire! Find a SAFE square to step on! 🟢",
          fen: "4r3/8/8/8/q3K3/8/8/k7 w - - 0 1",
          startPos: ksSq,
          targetSq: selectedSafe,
          correctMove: { from: "e4", to: selectedSafe }
        });
        break;

      case 17: // Unsafe Squares
        tasks.push({
          id: taskId,
          type: "board_click",
          question: "An enemy Rook on D4 is scanning. Click on the UNSAFE square! 🔴",
          fen: "8/8/8/8/3R4/8/8/k6K w - - 0 1",
          clickTargets: ["d1", "d2", "d3", "d5", "d6", "d7", "d8", "a4", "b4", "c4", "e4", "f4", "g4", "h4"],
          isDirectGridClick: true
        });
        break;

      case 18: // Protecting Pieces
        const defendPuzzles = [
          {
            question: "Your Bishop on d4 is under attack! Protect it by moving your Rook! 🛡️",
            fen: "3r4/8/8/8/3B4/8/8/R6K w - - 0 1",
            correctMove: { from: "a1", to: "d1" }
          },
          {
            question: "Your Knight on f4 is under attack! Protect it by moving your Rook! 🛡️",
            fen: "2b5/8/8/8/5N2/8/8/6RK w - - 0 1",
            correctMove: { from: "g1", to: "f1" }
          },
          {
            question: "Your Bishop on e5 is under attack! Protect it by moving your Knight! 🛡️",
            fen: "4r3/8/8/4B3/6N1/8/8/7K w - - 0 1",
            correctMove: { from: "g4", to: "f3" }
          },
          {
            question: "Your Knight on d5 is under attack! Protect it by moving your Pawn! 🛡️",
            fen: "3r4/8/8/3N4/8/8/2P4K/7R w - - 0 1",
            correctMove: { from: "c2", to: "c3" }
          },
          {
            question: "Your Bishop on f4 is under attack! Protect it by moving your King! 🛡️",
            fen: "5r2/8/8/8/5B2/8/6K1/7R w - - 0 1",
            correctMove: { from: "g2", to: "g3" }
          },
          {
            question: "Your Knight on e4 is under attack! Protect it by moving your Rook! 🛡️",
            fen: "5b2/8/8/8/4N3/8/8/3R3K w - - 0 1",
            correctMove: { from: "d1", to: "e1" }
          },
          {
            question: "Your Knight on c3 is under attack! Protect it by moving your Bishop! 🛡️",
            fen: "2r5/8/8/8/8/2N5/8/4B2K w - - 0 1",
            correctMove: { from: "e1", to: "d2" }
          },
          {
            question: "Your Pawn on d5 is under attack! Protect it by moving your Rook! 🛡️",
            fen: "3r4/8/8/3P4/8/8/8/R6K w - - 0 1",
            correctMove: { from: "a1", to: "d1" }
          },
          {
            question: "Your Bishop on e4 is under attack! Protect it by moving your Pawn! 🛡️",
            fen: "4r3/8/8/8/4B3/3P4/8/7K w - - 0 1",
            correctMove: { from: "d3", to: "d4" }
          },
          {
            question: "Your Knight on f5 is under attack! Protect it by moving your Pawn! 🛡️",
            fen: "2b5/8/8/5N2/8/6P1/7K/8 w - - 0 1",
            correctMove: { from: "g3", to: "g4" }
          },
          {
            question: "Your Knight on b5 is under attack! Protect it by moving your Pawn! 🛡️",
            fen: "1r6/8/8/1N6/8/8/P6K/8 w - - 0 1",
            correctMove: { from: "a2", to: "a3" }
          },
          {
            question: "Your Bishop on g5 is under attack! Protect it by moving your Pawn! 🛡️",
            fen: "6r1/8/8/6B1/8/8/5P1K/8 w - - 0 1",
            correctMove: { from: "f2", to: "f4" }
          },
          {
            question: "Your Knight on c4 is under attack! Protect it by moving your Pawn! 🛡️",
            fen: "2r5/8/8/8/2N5/1P6/7K/8 w - - 0 1",
            correctMove: { from: "b3", to: "b4" }
          },
          {
            question: "Your Bishop on d5 is under attack! Protect it by moving your Knight! 🛡️",
            fen: "2b5/8/8/3B4/8/8/4N2K/8 w - - 0 1",
            correctMove: { from: "e2", to: "f4" }
          },
          {
            question: "Your Knight on e5 is under attack! Protect it by moving your Bishop! 🛡️",
            fen: "4r3/8/8/4N3/8/8/7K/2B5 w - - 0 1",
            correctMove: { from: "c1", to: "f4" }
          }
        ];
        const puzzleData = defendPuzzles[t - 1];
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: puzzleData.question,
          fen: puzzleData.fen,
          correctMove: puzzleData.correctMove,
          successMessage: "Great defense! The piece is protected. 🛡️"
        });
        break;

      case 19: // Double Attacks
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Double Attack! Fork the enemy King and Rook with your Knight! 🔱",
          fen: "k7/8/4r3/8/4N3/8/8/K7 w - - 0 1",
          correctMove: { from: "e4", to: "c5" },
          successMessage: "Incredible Knight fork! 🔱"
        });
        break;

      case 20: // Free Captures
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Find the enemy piece that has no defenders and capture it! 💎",
          fen: "k7/8/4q3/4r3/8/4R3/8/K7 w - - 0 1",
          correctMove: { from: "e3", to: "e5" },
          successMessage: "Free piece captured! +5 points. 💎"
        });
        break;

      case 21: // Piece Trades
        tasks.push({
          id: taskId,
          type: "mcq",
          question: "Is trading your Bishop (3 points) for a Rook (5 points) a good trade? ⚖️",
          options: ["👍 Yes! (+2 point trade)", "👎 No! (-2 point trade)"],
          answer: "👍 Yes! (+2 point trade)"
        });
        break;

      case 22: // Castling Magic
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Move your King to perform KINGSIDE castling! 🏰",
          fen: "r3k2r/8/8/8/8/8/8/R3K2R w KQkq - 0 1",
          correctMove: { from: "e1", to: "g1" },
          successMessage: "Excellent Castling! King is safe. 🏰"
        });
        break;

      case 23: // Castling Rules
        tasks.push({
          id: taskId,
          type: "mcq",
          question: "Can you castle if your King is currently in CHECK? 🛑",
          options: ["❌ No, you must get out of check first", "✅ Yes, castling escapes the check"],
          answer: "❌ No, you must get out of check first"
        });
        break;

      case 24: // En Passant Capture
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Perform the special EN PASSANT capture with your pawn! 👻",
          fen: "8/8/8/4pP2/8/8/8/k6K w - e6 0 1",
          correctMove: { from: "f5", to: "e6" },
          successMessage: "Spooky ghost capture! En Passant complete! 👻"
        });
        break;

      case 25: // Board Setup
        tasks.push({
          id: taskId,
          type: "board_click",
          question: "Where does the White Queen starting home belong? 🏗️",
          fen: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
          clickTargets: ["d1"],
          isDirectGridClick: true
        });
        break;

      case 26: // Checking the King
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Attack the enemy King! Deliver a CHECK using your Rook! ⚡",
          fen: "k7/8/8/8/8/8/3R4/7K w - - 0 1",
          correctMove: { from: "d2", to: "d8" },
          successMessage: "Check! The opponent King must escape. ⚡"
        });
        break;

      case 27: // Getting Out of Check
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "You are in check! Move your King to a safe square! 🏃",
          fen: "k7/3r4/8/8/8/8/3K4/8 w - - 0 1",
          correctMove: { from: "d2", to: "c1" }, // or c2, e1, e2, c3, e3
          successMessage: "Safe and sound! King escaped the check. 🏃"
        });
        break;

      case 28: // What is Checkmate?
        tasks.push({
          id: taskId,
          type: "mcq",
          question: "The King is attacked and has no safe squares or escape moves. What is this? 💀",
          options: ["Checkmate (Game Over, Win!)", "Check (King can run away)", "Stalemate Draw (No moves)"],
          answer: "Checkmate (Game Over, Win!)"
        });
        break;

      case 29: // Rook Ladder Mate
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Slide your Rook to the 8th rank to deliver the Ladder Mate! 🪜",
          fen: "k7/2R5/8/8/8/8/1R6/7K w - - 0 1",
          correctMove: { from: "b2", to: "b8" },
          successMessage: "Ladder Checkmate! Game Over! 🏆"
        });
        break;

      case 30: // Queen Kiss of Death
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Deliver the 'Kiss of Death' checkmate with your Queen! 💋",
          fen: "k7/2Q5/1B6/8/8/8/8/7K w - - 0 1",
          correctMove: { from: "c7", to: "a7" },
          successMessage: "Kiss of Death Checkmate! 💋🏆"
        });
        break;

      case 31: // Scholar's Mate
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Find the 4-move checkmate square and deliver Scholar's Mate! 🎓",
          fen: "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5Q2/PPPP1PPP/RNB1KBNR w KQkq - 0 1",
          correctMove: { from: "f3", to: "f7" },
          successMessage: "Scholar's Checkmate! 🎓🏆"
        });
        break;

      case 32: // Stalemate Draw
        tasks.push({
          id: taskId,
          type: "mcq",
          question: "Is it Stalemate if a player has no legal moves and their King is NOT in check? 🤝",
          options: ["Yes, the game is a draw", "No, the player loses the game"],
          answer: "Yes, the game is a draw"
        });
        break;

      case 33: // Draws & Rules
        tasks.push({
          id: taskId,
          type: "mcq",
          question: "How many times must a position repeat on the board for a draw claim? 📝",
          options: ["3 Times", "5 Times", "10 Times"],
          answer: "3 Times"
        });
        break;

      case 34: // Back Rank Mate
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Deliver checkmate on the back rank! 🚪",
          fen: "6kk/5ppp/8/8/8/8/1R6/7K w - - 0 1",
          correctMove: { from: "b2", to: "b8" },
          successMessage: "Back-Rank Checkmate! 🚪🏆"
        });
        break;

      case 35: // Opening Traps
        tasks.push({
          id: taskId,
          type: "real_chess",
          question: "Capture the greedy pawn that attacked your Queen! 🪤",
          fen: "r1bqkbnr/pppp1ppp/2n5/4P3/8/5N2/PPP1PPPP/RNBQKB1R b KQkq - 0 1",
          correctMove: { from: "c6", to: "e5" },
          successMessage: "Greedy piece captured! 🪤"
        });
        break;

      case 36: // Graduation Exam
        if (t % 3 === 0) {
          tasks.push({
            id: taskId,
            type: "real_chess",
            question: "Deliver the final blow! Mate in 1! 🏆",
            fen: "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5Q2/PPPP1PPP/RNB1KBNR w KQkq - 0 1",
            correctMove: { from: "f3", to: "f7" },
            successMessage: "Scholar's Checkmate! 🎓🏆"
          });
        } else if (t % 3 === 1) {
          tasks.push({
            id: taskId,
            type: "mcq",
            question: "How many points is the Rook worth? 🛡️",
            options: ["1 Point", "3 Points", "5 Points", "9 Points"],
            answer: "5 Points"
          });
        } else {
          tasks.push({
            id: taskId,
            type: "collect_items",
            piece: "Rook",
            startPos: "d4",
            apples: ["d7", "g7"],
            question: "Slide straight and capture the stars for graduation! ⭐",
            itemIcon: "⭐"
          });
        }
        break;

      default:
        break;
    }
  }

  return tasks;
};
